import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../../../security/authentication/authentication.service';
import { NavigationService } from '../../../services/navigation.service';

@Component({
    selector: 'mcb-choose-organization',
    templateUrl: './choose-organization.component.html'
})
export class PortalLoginChooseOrganizationComponent {
    orgs = [];
    selectedOrg: any;

    constructor(
        private authService: AuthenticationService,
        private navService: NavigationService) {
        this.authService.getUserOrganizations().then(x => this.orgs = x);
    }

    async login() {
        this.authService.setUserOrganization(this.selectedOrg)
            .subscribe(async res => {
                await this.navService.goToAppropriateSecurityPageOrDashboard();
            });
    }
}
